(function (angular) {
	'use strict';

	var accountValueTableObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			smallerTableFontSize: '<',
			accountBreakdown: '<'
		},
		controller: [
			'DashboardPerformanceService',
			AccountValueTableFunction
		],
		controllerAs: 'accountValueTable'
	};

	angular
		.module('investorDashboard')
		.component('accountValueTable', accountValueTableObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/investor-dashboard/account-value-table.html';
	}

	function AccountValueTableFunction(
		DashboardPerformanceService
	) {
		var accountValueTable = this;

		accountValueTable.setActiveMobileColumn = function(column) {
			DashboardPerformanceService.setActiveMobileColumn(accountValueTable.accountBreakdown, column);
		};
		
		accountValueTable.toggleTableSection = function(section) {
			DashboardPerformanceService.toggleTableSection(accountValueTable.accountBreakdown, section);
		};

		accountValueTable.$onChanges = function() {
			accountValueTable.loadingPerformance = angular.isUndefined(accountValueTable.accountBreakdown);
			accountValueTable.hasData = !angular.equals({}, accountValueTable.accountBreakdown);
		};
	}
})(window.angular);